/* eslint-disable prefer-template */
/* eslint-disable max-len */
import React, { useEffect, useRef } from 'react';
import './styles.css';
import { getSpeakers } from '../../../libs/apis/webinarApi';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SpeakersList from './speakersList';
import { useIntl } from 'react-intl';

function Speaker(props)
{

	const { webinarData, handleClose }=props;
	const ref = useRef(null);
	const intl = useIntl();

	// const getSpeakersData = async () =>
	// {
	// 	// const res=await getSpeakers(webinarData._id);
	// 	const res=await getSpeakers('6557432f27819a193accc338');

	// };

	// useEffect(() =>
	// {
	// 	getSpeakersData();
	// }, []);

	const handleNavigate=(link) =>
	{
		window.open(link, '_blank');
	};

	return (
		<div className='flexCol fullH' ref={ref}>
			<div className='flexRow aCntr jBtwn pdngXS'>
				<img src='icons/close.svg' alt='close' className='pointer' onClick={handleClose} />
				<div className='flexMinWidthCol aCntr'>
					<span className='mHdng' ><b>{intl.formatMessage({ id: 'Speakers', defaultMessage: 'Speakers' })}</b></span>
				</div>
			</div>
			<SpeakersList webinarData={webinarData} handleNavigate={handleNavigate} />
		</div>
	);
}

Speaker.propTypes =
{
	webinarData : PropTypes.any,
	handleClose : PropTypes.any
};

const mapStateToProps = (state) =>
{
	return {
		webinarData	: state.webinar.webinarData
	};
};

export default connect(
	mapStateToProps,
	null,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.webinar.webinarData === next.webinar.webinarData
			);
		}
	}
)(Speaker);